<h2>{{ "dtmMainPageLib.subpage.kpo.aboutProject.projectScheduleTitle" | transloco }}</h2>
<div
    class="scrollable-container"
    *ngrxLet="{ isLeftScrollButtonDisabled: isLeftScrollButtonDisabled$, isRightScrollButtonDisabled: isRightScrollButtonDisabled$ } as vm"
>
    <button
        class="button-icon left-arrow"
        type="button"
        [disabled]="vm.isLeftScrollButtonDisabled"
        (click)="scrollLeft()"
        [attr.aria-disabled]="vm.isLeftScrollButtonDisabled"
        [attr.aria-label]="'dtmUi.carousel.previousSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-left"></dtm-ui-icon>
    </button>
    <div
        class="scrollable-area"
        #scrollArea
        [dtmUiHorizontalScroll]="!vm.isLeftScrollButtonDisabled || !vm.isRightScrollButtonDisabled"
        dtmUiScrollTracker
        [ngSwitch]="activeLanguage$ | ngrxPush"
        (scrollTrack)="changeScrollButtonState($event)"
    >
        <img
            *ngSwitchDefault
            ngSrc="assets/images/kpo/schedule_pl.png"
            [alt]="'dtmMainPageLib.subpage.kpo.aboutProject.projectScheduleImageAltText' | transloco"
            height="662"
            width="1392"
            ngSrcset="100w, 200w"
        />
        <img
            *ngSwitchCase="'en'"
            ngSrc="assets/images/kpo/schedule_en.png"
            [alt]="'dtmMainPageLib.subpage.kpo.aboutProject.projectScheduleImageAltText' | transloco"
            height="662"
            width="1392"
            ngSrcset="100w, 200w"
        />
    </div>
    <button
        class="button-icon right-arrow"
        type="button"
        [disabled]="vm.isRightScrollButtonDisabled"
        (click)="scrollRight()"
        [attr.aria-disabled]="vm.isRightScrollButtonDisabled"
        [attr.aria-label]="'dtmUi.carousel.nextSlideAriaLabel' | transloco"
    >
        <dtm-ui-icon name="arrow-right"></dtm-ui-icon>
    </button>
</div>
